import http from '@/utils/http'
export const getOverflowInfo = data => http.get("/kg-notification/api/empty/email", {
    params: data
}) //查找溢滿通知
export const exportCord = data => http.get('/kg-notification/api/empty/email/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getOverflowInfo,
    exportCord
}